export default "__VITE_ASSET__11aadd9d__"